export const BASE_TITLE = "Varisht -";

export const CONSTANTS = {
  title: {
    login: `${BASE_TITLE} Login`,
    dashboard: `${BASE_TITLE} Dashboard`,
    profile: `${BASE_TITLE} Profile`,
    settings: `${BASE_TITLE} Settings`,
    logout: `${BASE_TITLE} Logout`,
    institute: `${BASE_TITLE} Institute`,
    spocPremise: `${BASE_TITLE} SPOC & Premise`,
    compliance: `${BASE_TITLE} Compliance`,
    feeStructure: `${BASE_TITLE} Fee Structure`,
    academics: `${BASE_TITLE} Academics`,
    lessonPlan: `${BASE_TITLE} Lesson Plans`,
    material: `${BASE_TITLE} Materials`,
    assessment: `${BASE_TITLE} Assessment`,
    branding: `${BASE_TITLE} Branding`,
    localization: `${BASE_TITLE} Localization`,
    rbac: `${BASE_TITLE} Roles`,
    auditTrail: `${BASE_TITLE} Audit Trail`,
    help: `${BASE_TITLE} Help & Documentation`,
  },
  dropdownDefaultKey: "select",
  dropdownDefaultValue: "Select a value",
};
